import { render, staticRenderFns } from "./kv-popup.vue?vue&type=template&id=2ffd1b42"
import script from "./kv-popup.vue?vue&type=script&lang=js"
export * from "./kv-popup.vue?vue&type=script&lang=js"
import style0 from "./kv-popup.vue?vue&type=style&index=0&id=2ffd1b42&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports